import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  learnablesCount: {
    id: 'topic_featured_number_scenarios',
  },

  scenarioDetails: {
    id: 'topic_lesson_details',
  },
});
